import type { ReviewDetailAllOfTwoInstructorResponse } from './reviewDetailAllOfTwoInstructorResponse';
import type { ReviewDetailAllOfTwoUserVote } from './reviewDetailAllOfTwoUserVote';

export type ReviewDetailAllOfTwo = {
  /** 강사 응답 */
  instructorResponse?: ReviewDetailAllOfTwoInstructorResponse;
  /** 현재 사용자의 투표 상태 */
  userVote?: ReviewDetailAllOfTwoUserVote;
};
